<div>
  <app-e-waste-legislation-filters *ngIf="categories"
                                   [categories]="categories"
                                   (search)="searchData($event)">
  </app-e-waste-legislation-filters>
  <mat-divider></mat-divider>
  <app-e-waste-legislation-bar-chart *ngIf="data"
                                     [title]="text"
                                     [subtitle]="subtitle"
                                     [categoriesFilter]="categoryFilters"
                                     [data]="data">
  </app-e-waste-legislation-bar-chart>
</div>
